import React, { useCallback, useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useReceivement } from 'src/hooks/useReceivement'
import {
  closeDivergence,
  getDivergentProducts,
  postCalculateDivergence
} from 'src/services/receivement/divergenceService'
import * as S from './ReceivementDivergence.styles'
import { TableProductDivergence } from './TableProductDivergence'
import { TableWrongProduct } from './TableWrongProduct'

const ReceivementDivergence = () => {
  const { receivementId } = useParams()
  const history = useHistory()

  const [divergences, setDivergences] = useState(null)
  const [isCalcDivergence, setIsCalcDivergence] = useState(false)
  const [isButtonClicked, setIsButtonClicked] = useState(false)
  const { supervisorBadge } = useReceivement({ validateSupervisor: true })

  const handleCloseBatch = useCallback(async () => {
    setIsButtonClicked(true)
    const response = await closeDivergence(supervisorBadge, receivementId)
    if (response.isOk) {
      history.push(`/receivement/${receivementId}/overview`)
    } else {
      toast.error('Falha ao finalizar a divergência')
      setIsButtonClicked(false)
    }
  }, [history, receivementId, supervisorBadge])

  const handleSetDivergences = useCallback((products) => {
    setIsCalcDivergence(true)
    setDivergences(products)
  }, [])

  const getDivergences = useCallback(async () => {
    const response = await getDivergentProducts(supervisorBadge, receivementId)
    if (response.isOk) {
      handleSetDivergences(response.data.produtos)
    } else {
      toast.error('Falha ao calcular a divergência')
    }
  }, [supervisorBadge, receivementId, handleSetDivergences])

  const isCloseButtonDisabled = useCallback(() => {
    if (divergences === null) {
      return true
    }

    return divergences
      .flatMap((divergence) => divergence.lotes_divergencia)
      .some(
        (batch) =>
          batch.status === 'SOLICITAR_RECONTAGEM' ||
          batch.status === 'NAO_LOCALIZADO'
      )
  }, [divergences])

  const initialize = useCallback(async () => {
    if (!supervisorBadge) {
      return
    }

    if (isCalcDivergence === false) {
      getDivergences()
    }
  }, [
    receivementId,
    isCalcDivergence,
    supervisorBadge,
    getDivergences,
    handleSetDivergences
  ])

  useEffect(() => {
    initialize()
  }, [initialize])

  if (divergences === null) {
    return <h1>Carregando Divergências...</h1>
  }

  return (
    <S.WrapperDivergence>
      <S.WrapperHeader>
        <S.Title>Divergência</S.Title>
        <S.Button
          onClick={() => handleCloseBatch()}
          disabled={isCloseButtonDisabled() || isButtonClicked}
        >
          Finalizar
        </S.Button>
      </S.WrapperHeader>
      <TableProductDivergence
        title="Divergência de Quantidade"
        products={divergences.filter(({ tipo }) =>
          ['QUANTIDADE_MAIOR', 'QUANTIDADE_MENOR'].includes(tipo)
        )}
        badge={supervisorBadge}
        updateTable={() => getDivergences()}
      />
      <TableWrongProduct
        title="Produtos Errados"
        products={divergences.filter(({ tipo }) => tipo === 'PRODUTO_ERRADO')}
      />
    </S.WrapperDivergence>
  )
}

export default ReceivementDivergence
